module.exports = __webpack_public_path__ + "img/input_4.ee88aee6.png";